import { axiosPrivate } from "@/modules/common/api";

export async function getUserMeWithPermissions() {
  const res = await axiosPrivate.post(`/api/v1/users/me/permissions/`);
  return res;
}

export async function getAllUsers(data: any) {
  const res = await axiosPrivate.post(`/api/v1/users/all/`, data);
  return res;
}
export async function getAllUsersByRoleCodename(data: any) {
  const res = await axiosPrivate.post(`/api/v1/users/all/by-role-codename`, data);
  return res;
}

export async function createUser(data: any) {
  const res = await axiosPrivate.post(`/api/v1/users/`, data);
  return res;
}

export async function updateUser(user_id: number, data: any) {
  const res = await axiosPrivate.patch(`/api/v1/users/${user_id}/`, data);
  return res;
}

export async function deleteUser(user_id: number) {
  const res = await axiosPrivate.delete(`/api/v1/users/${user_id}/`);
  return res;
}

export async function getUserById(user_id: number) {
  const res = await axiosPrivate.get(`/api/v1/users/${user_id}/`);
  return res;
}

export async function getRolesByUserId(user_id: number) {
  const res = await axiosPrivate.get(`/api/v1/users/${user_id}/roles/`);
  return res;
}

export async function updateUsersRoles(user_id: number, data: any) {
  const res = await axiosPrivate.patch(`/api/v1/users/${user_id}/roles/`, data);
  return res;
}
